import React from 'react'

function Reports() {
    return (
        <div>reports</div>
    )
}

export default Reports